import {
    selectTotalVisibleQuestionsWithAssistanceConditions,
    selectTotalVisibleQuestionsWithAssistance,
} from "features/qualityForm/qualityFormSlice";
import { useStrings } from "features/i18n/useStrings";
import { shallowEqual } from "react-redux";
import { GuxIcon, GuxTooltip } from "genesys-spark-components-react";
import "./EvaluationAssistanceStatus.less";
import strings from "./EvaluationAssistanceStatus.strings";
import { useAppSelector } from "app/hooks";

export function EvaluationAssistanceStatus() {
    const t = useStrings(strings);

    const { totalQuestions, totalQuestionsWithAssistance } = useAppSelector(
        (state) => {
            const totalQuestions =
                selectTotalVisibleQuestionsWithAssistanceConditions(
                    state
                ).length;
            const totalQuestionsWithAssistance =
                selectTotalVisibleQuestionsWithAssistance(state);
            return {
                totalQuestions,
                totalQuestionsWithAssistance,
            };
        },
        shallowEqual
    );
    return (
        <div
            className="EvaluationAssistanceStatus"
            data-testid="evaluation-assistance-status"
        >
            <div className="question-status">
                <span className="evaluation-assistance-quote">
                    <GuxIcon
                        iconName="quote-left"
                        decorative={true}
                        data-testid="evaluation-assistance-status-icon"
                    />
                </span>
                <div className="content">
                    <span
                        className="evaluation-assistance-label"
                        data-testid="evaluation-assistance-status-label"
                    >
                        {t.label}
                    </span>
                    <div className="vertical-line"></div>
                    <span
                        className="evaluation-assistance-count"
                        data-testid="evaluation-assistance-status-count"
                    >
                        {t.status.questionCount({
                            count: totalQuestionsWithAssistance,
                        })}
                    </span>
                </div>
                <GuxTooltip>
                    {t.status.tooltipText({
                        answeredQuestionCount: totalQuestionsWithAssistance,
                        totalQuestionCount: totalQuestions,
                    })}
                </GuxTooltip>
            </div>
        </div>
    );
}
